import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";
import "./AllSubjectsCategory.scss";
import Home from "../Assets/images/home.svg";
import { getSubjectWiseSubSubject } from "../services/getSubjectWiseSubSubject";

const AllSubjectsCategory = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [subSubjectData, setSubSubjectData] = useState([]);
  const [activeTab, setActiveTab] = useState(null);
  const [filterLetter, setFilterLetter] = useState("All");
  const [currentPage, setCurrentPage] = useState(1);
  const dekstopRef = useRef(null);
  const ITEMS_PER_PAGE = 10;

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getSubjectWiseSubSubject();
        setSubSubjectData(response.data);
        if (response.data.length > 0)
          setActiveTab(response.data[0].mainSubjectId);
      } catch (error) {
        return error;
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (dekstopRef && dekstopRef.current) {
      dekstopRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [activeTab]);

  const handleTabClick = (id) => {
  if (activeTab === id) {
    setActiveTab(null); 
  } else {
    setActiveTab(id); 
  }

  setFilterLetter("All");
  setCurrentPage(1);
};


  const activeSubSubjects =
    subSubjectData.find((subject) => subject.mainSubjectId === activeTab)
      ?.subSubject || [];

  const filteredSubSubjects = activeSubSubjects.filter((sub) => {
    if (!filterLetter || filterLetter === "All") return true;
    return sub.subSubjectName
      .toUpperCase()
      .startsWith(filterLetter.toUpperCase());
  });

  const totalPages = Math.ceil(filteredSubSubjects.length / ITEMS_PER_PAGE);

  const paginatedSubSubjects = filteredSubSubjects.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE,
  );

  const handlePaginationClick = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  const getPageNumbers = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
      return pages;
    }
    pages.push(1);
    if (currentPage > 3) pages.push("...");
    const start = Math.max(2, currentPage - 1);
    const end = Math.min(totalPages - 1, currentPage + 1);
    for (let i = start; i <= end; i++) pages.push(i);
    if (currentPage < totalPages - 2) pages.push("...");
    pages.push(totalPages);
    return pages;
  };
  const sortedSubjectData = [...subSubjectData].sort((a, b) =>
    a.mainSubject.localeCompare(b.mainSubject),
  );
  return (
    <div className="container my-5 ">
      {sortedSubjectData.length > 0 && (
        <>
          <div className="subject-tabs-div">
            <div className="row">
              <div className="col-lg-4 col-md-4">
                <ul className="ft-link nav-tabs">
                  {sortedSubjectData.map((subject) => (
                    <li key={subject.mainSubjectId} className={`nav-items`}>
                      <div
                        className={`d-flex justify-content-between align-items-center tab-header ${activeTab === subject.mainSubjectId ? "tab-active" : ""}`}
                      >

                        <Link
    to={`/subject/${subject.subjectUrl}`}
    className="d-flex align-items-center gap-3 text-decoration-none flex-grow-1"
  >
                        <div className="d-flex align-items-center gap-3">
                          <img
                            src={Home}
                            alt={subject.mainSubject}
                            width={25}
                            height={25}
                          />
                          <span className="text-capitalize link-text">
                            {subject.mainSubject.replace(" Academic Help", "")}
                          </span>
                        </div>


  </Link>

                        <i
                        onClick={() => handleTabClick(subject.mainSubjectId)}
                          className={`accordion-icon fa-solid fs-6 visibility-hover ${
                            isMobile && activeTab === subject.mainSubjectId
                              ? "fa-solid fa-chevron-down"
                              : "fa-solid fa-chevron-right"
                          }`}
                        />
                      </div>

                      {isMobile && activeTab === subject.mainSubjectId && (
                        <div
                          id="tab-content"
                          className="tabcontent"
                          style={{ background: "#fff", paddingBottom:"15px" }}
                        >
                          <div
                            id="mobile-subjects"
                            className="mt-2 subject-tabs"
                          >
                            <ul className="d-flex justify-content-start flex-wrap p-0">
                              {paginatedSubSubjects.length > 0 ? (
                                paginatedSubSubjects.map((sub, index) => (
                                  <li key={index}>
                                    <Link
                                      to={`/${subject.subjectUrl}/${sub.subSubjectUrl}`}
                                    >
                                      {sub.subSubjectName.replace(
                                        " Academic Help",
                                        "",
                                      )}
                                    </Link>
                                  </li>
                                ))
                              ) : (
                                <div className="p-3 text-center">
                                  <p className="fs-5 mb-0">
                                    No sub-subject found.
                                  </p>
                                </div>
                              )}
                            </ul>
                          </div>
                          {totalPages > 1 && (
                            <div className="mobile-pagination">
                              <Pagination>
                                <PaginationItem disabled={currentPage === 1}>
                                  <PaginationLink
                                    previous
                                    onClick={() =>
                                      handlePaginationClick(currentPage - 1)
                                    }
                                  />
                                </PaginationItem>
                                {getPageNumbers().map((p, i) =>
                                  p === "..." ? (
                                    <PaginationItem key={i} disabled>
                                      <PaginationLink>…</PaginationLink>
                                    </PaginationItem>
                                  ) : (
                                    <PaginationItem
                                      key={i}
                                      active={p === currentPage}
                                    >
                                      <PaginationLink
                                        onClick={() => handlePaginationClick(p)}
                                      >
                                        {p}
                                      </PaginationLink>
                                    </PaginationItem>
                                  ),
                                )}
                                <PaginationItem
                                  disabled={currentPage === totalPages}
                                >
                                  <PaginationLink
                                    next
                                    onClick={() =>
                                      handlePaginationClick(currentPage + 1)
                                    }
                                  />
                                </PaginationItem>
                              </Pagination>
                            </div>
                          )}
                        </div>
                      )}
                    </li>
                  ))}
                </ul>
              </div>

              {!isMobile && (
                <div className="col-lg-8 col-md-8" ref={dekstopRef}>
                  <div id="tab-content" className="tabcontent">
                    <div className="subject-tabs">
                      <h2 className="mb-4 text-start">
                        {sortedSubjectData
                          .find(
                            (subject) => subject.mainSubjectId === activeTab,
                          )
                          ?.mainSubject?.replace(" Academic Help", "") ||
                          "Select a Subject"}
                      </h2>
                      <ul className="d-flex justify-content-start flex-wrap p-0">
                        {paginatedSubSubjects.length > 0 ? (
                          paginatedSubSubjects.map((sub) => (
                            <li key={sub._id}>
                              <Link
                                to={`/${
                                  sortedSubjectData.find(
                                    (subject) =>
                                      subject.mainSubjectId === activeTab,
                                  )?.subjectUrl
                                }/${sub.subSubjectUrl}`}
                              >
                                <span className="text-capitalize">
                                  {sub.subSubjectName.replace(
                                    " Academic Help",
                                    "",
                                  )}
                                </span>
                              </Link>
                            </li>
                          ))
                        ) : (
                          <p className="fs-3">No sub-subject found.</p>
                        )}
                      </ul>
                    </div>

                    {totalPages > 1 && (
                      <div className="float-end">
                        <Pagination>
                          <PaginationItem disabled={currentPage === 1}>
                            <PaginationLink
                              previous
                              onClick={() =>
                                handlePaginationClick(currentPage - 1)
                              }
                            />
                          </PaginationItem>
                          {getPageNumbers().map((page, index) =>
                            page === "..." ? (
                              <PaginationItem key={index} disabled>
                                <PaginationLink>...</PaginationLink>
                              </PaginationItem>
                            ) : (
                              <PaginationItem
                                key={index}
                                active={currentPage === page}
                              >
                                <PaginationLink
                                  onClick={() => handlePaginationClick(page)}
                                >
                                  {page}
                                </PaginationLink>
                              </PaginationItem>
                            ),
                          )}
                          <PaginationItem disabled={currentPage === totalPages}>
                            <PaginationLink
                              next
                              onClick={() =>
                                handlePaginationClick(currentPage + 1)
                              }
                            />
                          </PaginationItem>
                        </Pagination>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AllSubjectsCategory;
